/**
 * Placement — WHERE on a channel a post lands. Mirror of
 * PLACEMENTS_BY_CHANNEL in api_gateway/models/tendv2_settings.py; keep the
 * two in lockstep. First entry = the channel default (what a null
 * placement means). Channels absent here have one surface — render no
 * placement control.
 */

export const PLACEMENTS_BY_CHANNEL: Record<string, readonly string[]> = {
  snapchat: ['story', 'saved_story', 'spotlight'],
  // 'feed' displays as "Grid" on instagram. reel_off_grid = Reels tab
  // only (grid-protective brands); story = single media, Business
  // accounts only, caption dropped.
  instagram: ['feed', 'reel', 'reel_off_grid', 'story'],
  facebook: ['feed', 'reel', 'story'],
  // reddit placement = the POST FORMAT (text+image can't share a Reddit
  // post): image_post = the rendered overlay, link_post = title + tracked
  // link. The subreddit itself is per-brand data, not a placement.
  reddit: ['image_post', 'link_post'],
};

export const PLACEMENT_LABELS: Record<string, string> = {
  story: 'Story',
  saved_story: 'Saved Story',
  spotlight: 'Spotlight',
  feed: 'Feed',
  reel: 'Reel',
  reel_off_grid: 'Reel · off grid',
  image_post: 'Image Post',
  link_post: 'Link Post',
};

/** Channels that name the same surface differently (IG's feed = the grid). */
const CHANNEL_PLACEMENT_LABELS: Record<string, Record<string, string>> = {
  instagram: { feed: 'Grid' },
};

/** Placement options for a channel, or null when it has a single surface. */
export function placementsFor(channel: string): readonly string[] | null {
  return PLACEMENTS_BY_CHANNEL[channel] || null;
}

export function defaultPlacement(channel: string): string | null {
  const options = PLACEMENTS_BY_CHANNEL[channel];
  return options ? options[0] : null;
}

export function placementLabel(placement: string, channel?: string): string {
  return (
    (channel && CHANNEL_PLACEMENT_LABELS[channel]?.[placement]) ||
    PLACEMENT_LABELS[placement] ||
    placement
  );
}
